export const carrierRequestServices = [
  'tracking',
  'rating',
  'profinder',
  'ebol',
  'dispatching',
  'documents',
  'invoice',
  'provisioning',
] as const

export type CarrierRequestService = (typeof carrierRequestServices)[number]
